<template>
  <Fragment>
    <div v-if="values.regions" class="my-2">
      <b>Регионы: </b>
      <BCollapser
        :list="values.regions"
        :min-height-by-count="1"
      />
    </div>

    <div v-if="values.municipalities" class="my-2">
      <b>Муниципальные районы: </b>
      <BCollapser
        :list="values.municipalities"
        :min-height-by-count="1"
      />
    </div>

    <div v-if="values.schools" class="my-2">
      <b>Образовательные организации: </b>
      <BCollapser
        :list="values.schools"
        :min-height-by-count="1"
      />
    </div>
  </Fragment>
</template>

<script>
import { Fragment } from 'vue-fragment'
import BCollapser from '@/components/common/BCollapser.vue'


const getAteStringList = (data) => {
  if (!data?.length) return null
  return data[0]?.name ? data.map((_) => _.name) : data
}

export default {
  name: 'BTableItemAte',
  components: {
    Fragment,
    BCollapser,
  },
  props: {
    data: {
      type: Object,
      required: true,
      validator: (prop) => (
        Array.isArray(prop.regions)
        && Array.isArray(prop.municipalities)
        && Array.isArray(prop.schools)
      ),
    },
  },
  computed: {
    values() {
      const { data } = this
      return {
        regions: getAteStringList(data.regions),
        municipalities: getAteStringList(data.municipalities),
        schools: getAteStringList(data.schools),
      }
    },
  },
}
</script>
